import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, Typography,
} from '@mui/material';

/**
 * Shown when eBay rejects a post for missing required item specifics (same
 * flow as the iOS missing-fields overlay). The values are saved onto the
 * product (consolidatedData + fieldsRequired) so they stick for later posts,
 * then the post is retried.
 *
 * Props: fields (string[] | null), onClose, onSubmit({ [field]: value })
 */
export default function MissingEbayFieldsDialog({ fields, onClose, onSubmit }) {
  const [values, setValues] = useState({});
  useEffect(() => { setValues({}); }, [fields]);

  const filled = Object.fromEntries(Object.entries(values).filter(([, v]) => v.trim()));

  return (
    <Dialog open={!!fields?.length} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>eBay needs a few more details</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          eBay requires these fields for this category.
        </Typography>
        <Stack spacing={2}>
          {(fields || []).map((field, i) => (
            <TextField
              key={field}
              autoFocus={i === 0}
              size="small"
              label={field}
              value={values[field] || ''}
              onChange={(e) => setValues((prev) => ({ ...prev, [field]: e.target.value }))}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={Object.keys(filled).length === 0} onClick={() => onSubmit(filled)}>
          Post to eBay
        </Button>
      </DialogActions>
    </Dialog>
  );
}
